<div class="report-container">

    <ng-container *ngIf="!showProjectDetails && !showPropertyDetails">

        <app-report-sub-menu [menuList]="overViewMenu"
            (menuChangeValue)="menuChangeValue($event)"></app-report-sub-menu>
            <ng-container *ngIf="houseVillaOverviewLoading">
                <app-skeleton-loader [reportType]="chartView.overView" [height]="'150px'"
                    ></app-skeleton-loader>
            </ng-container>
        <div class="report-tabsection"  id="{{ houseVillasMenuEnum.overview}}"
            [ngClass]="{ 'scroll': currentScroll === houseVillasMenuEnum.overview}">
            <div class="report-overview report-overview-3col" *ngIf="!houseVillaOverviewLoading">
                <app-overview-card
                [card_title]="'reports.totalLandsForProperties'"
                [total_current]="overViewSummary?.total_land_current"
                [untillDate]="overViewSummary?.untillDate"
                [total_prev]="overViewSummary?.total_land_prev"
                [total_percentage]="overViewSummary?.total_percentage"></app-overview-card>

                <app-overview-card
                    [card_title]="'reports.averageLandArea'"
                    [total_current]="overViewSummary?.average_land_current"
                    [untillDate]="overViewSummary?.untillDate"
                    [total_prev]="overViewSummary?.average_land_prev"
                    [total_percentage]="overViewSummary?.average_total_percentage"
                    [uniType]="UnitTypeEnum.sqm"></app-overview-card>


                <app-overview-card
                    [card_title]="'reports.landDevelopmentRate'"
                    [total_current]="overViewSummary?.land_development_current"
                    [untillDate]="overViewSummary?.untillDate"
                    [total_prev]="overViewSummary?.land_development_prev"
                    [total_percentage]="overViewSummary?.landDevlopment_total_percentage"
                    [uniType]="UnitTypeEnum.percentage"></app-overview-card>

            </div>
        </div>

        <div class="report-model">
            <div class="report-model-header">
                <div class="info">
                    <h3>{{"reports.theSupplyOfResidentialLands" | translate}} {{houseVillaChart.length ? houseVillaChart.length
                        :''}} {{'reports.years'| translate}}</h3>
                </div>

            </div>
            <ng-container *ngIf="houseVillaChartLoading">
                <app-skeleton-loader [reportType]="chartView.barChart"
                ></app-skeleton-loader>
            </ng-container>
            <ng-container *ngIf="!houseVillaChartLoading && houseVillaChart.length > 0">
                <app-report-charts
                [data]="houseVillaChart"
                [chartType]="chartView.barChart"
                [name]="'houseVillasbarChart'"
            ></app-report-charts>

            </ng-container>
             <div class="data_unavail" *ngIf="!houseVillaChartLoading && houseVillaChart.length == 0">
              <span>
                  {{"reports.dataComingSoon" | translate}}
              </span>
          </div>




        </div>


         <!-- Independents villas -->
        <div  class="report-tabsection" [ngClass]="{ 'scroll': currentScroll === houseVillasMenuEnum.independent_villas}"
            id="{{ houseVillasMenuEnum.independent_villas }}">

            <app-report-year-dropdown
            [reportType]="'independent'"
            (selectedYear)="selectedYear($event)"
        ></app-report-year-dropdown>

            <div class="report-model" >

                <div class="report-model-header">
                    <div class="info">
                        <h3>{{"reports.independentProperties" | translate}}</h3>

                    </div>

                </div>
                    <app-housevilla-inventory-properties [showLoader]="!independentVillasdataLoading"
                    [tableColumns]="independentVillasColumns"
                    [dataLength]="independentVillasCount"
                    [tableData]="independentVillasdata"
                    (pageEvent)="onPageEvent($event, houseVillasMenuEnum.independent_villas)"
                    (sort)="sortData($event, houseVillasMenuEnum.independent_villas)"
                    [allowExcelDownload]="true"
                    (excelDownload)="downloadExcel($event, 'independent', 'a')" [downloadLoading]="downloadLoading['a']"
                    [showEstaterText]="true"
                    [type]="'independent'"
                >
                </app-housevilla-inventory-properties>



            </div>
        </div>

        <!-- Governmental Villas -->
        <div  class="report-tabsection" [ngClass]="{ 'scroll': currentScroll === houseVillasMenuEnum.governmental_villas}"
            id="{{ houseVillasMenuEnum.governmental_villas }}">

            <app-report-year-dropdown
            [reportType]="'governor'"
            (selectedYear)="selectedYear($event)"
        ></app-report-year-dropdown>


            <div class="report-model">

                <div class="report-model-header">
                    <div class="info">
                        <h3>{{"reports.governmentalProperties" | translate}}</h3>

                    </div>

                </div>
                    <app-housevilla-inventory-properties [showLoader]="!governmentalVillasdataLoading"
                    [tableColumns]="governmentalVillasColumns"
                    [dataLength]="governmentalVillasCount"
                    [tableData]="governmentalVillasdata"
                    (pageEvent)="onPageEvent($event, houseVillasMenuEnum.governmental_villas)"
                    (sort)="sortData($event, houseVillasMenuEnum.governmental_villas)"
                    [allowExcelDownload]="true"
                    (excelDownload)="downloadExcel($event, 'govt', 'b')" [downloadLoading]="downloadLoading['b']"
                    [showEstaterText]="true"
                     [type]="'govt'">
                </app-housevilla-inventory-properties>



            </div>
        </div>

        <!-- Projects villas -->
        <div  class="report-tabsection" [ngClass]="{ 'scroll': currentScroll === houseVillasMenuEnum.projects}"
            id="{{ houseVillasMenuEnum.projects}}">

            <app-report-year-dropdown
            [reportType]="'projects'"
            (selectedYear)="selectedYear($event)"
        ></app-report-year-dropdown>

            <div class="report-model" >


                <app-datatable-title [title]="'reports.projects'" [count]="projectsCount" [countTitle]="'reports.totalProjects'"></app-datatable-title>

                    <app-housevilla-inventory-projects [showLoader]="!projectsdataLoading"
                    [tableColumns]="projectsColumns"
                    [dataLength]="projectsCount"
                    [tableData]="projectsdata"
                    (pageEvent)="onPageEvent($event, houseVillasMenuEnum.projects)"
                    (sort)="sortData($event, houseVillasMenuEnum.projects)"
                    [allowExcelDownload]="true"
                    (excelDownload)="downloadExcel($event, 'project', 'c')" [downloadLoading]="downloadLoading['c']"
                    [showEstaterText]="true">
                </app-housevilla-inventory-projects>


            </div>
        </div>
    </ng-container>

</div>
